module.exports = __webpack_public_path__ + "fonts/Latinka-ExtraLightItalic.cfa88925.ttf";